import {CUSTOMER_KEY, LOGIN_URL, LOGOUT_URL, REGISTER_URL} from "../constants/constants";
//
// async function loginUser(email: string, password: string) {
//     try {
//         const response = await fetch(LOGIN_URL, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({email, password}),
//             // credentials: 'include'
//         });
//
//         const responseData = await response.json();
//
//         if (responseData.success) {
//             sessionStorage.setItem(CUSTOMER_KEY, JSON.stringify(responseData.data))
//             return {
//                 success: true,
//                 data: responseData.data
//             };
//         } else if (!responseData.success) {
//             const errorMessage = responseData.error?.[0]?.message || "An error occurred. Please try again.";
//             return {
//                 success: false,
//                 error: errorMessage || "Unknown error occurred."
//             };
//         } else {
//             return {
//                 success: false,
//                 error: `Server responded with status: ${response.status}`
//             };
//         }
//
//     } catch (error) {
//         return {
//             success: false,
//             error: "Unable to connect. Please check your internet connection and try again."
//         };
//     }
// }
//
//
// async function registerUser(userInfo: {
//     first_name: string,
//     last_name: string,
//     gender: 'male' | 'female' | 'nonBinary',
//     email: string,
//     phone: string,
//     password: string,
//     customer_type: 0 | 1 | 2,
// }) {
//     try {
//         const response = await fetch(REGISTER_URL, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(userInfo),
//             // credentials: 'include'
//         });
//
//         const responseData = await response.json();
//
//         if (responseData.success) {
//             return {
//                 success: true,
//                 data: responseData.data
//             };
//         } else if (!responseData.success) {
//             const errorMessage = responseData.error?.[0]?.message || "An error occurred. Please try again.";
//             return {
//                 success: false,
//                 error: errorMessage || "Unknown error occurred."
//             };
//         } else {
//             return {
//                 success: false,
//                 error: `Server responded with status: ${response.status}`
//             };
//         }
//
//     } catch (error) {
//         return {
//             success: false,
//             error: "Unable to connect. Please check your internet connection and try again."
//         };
//     }
// }
//
// const logoutUser = async (): Promise<boolean> => {
//     try {
//         const response = await fetch(LOGOUT_URL, {
//             method: 'POST',
//             credentials: 'include',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//         });
//
//         if (response.status !== 200) {
//             const responseData = await response.json();
//             console.error('Logout failed:', responseData);
//             return false;
//         }
//
//         return true;
//     } catch (error) {
//         console.error('Network error during logout:', error);
//         return false;
//     }
// };
//
const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

// export {loginUser, registerUser, logoutUser, validateEmail};
export {validateEmail};
